import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';

@Component({
  selector: 'timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css']
})
export class TimelineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    AOS.init({
      duration: 100,
      startEvent: 'load'
    });
  }

  close() {
    let navOptions = document.getElementById('options')
    if (navOptions?.classList.toString() == "options") {
      navOptions.classList.remove("options")
      navOptions.classList.toggle("optionsClosed")
    }
  }

}
